import { BaseException } from '../BaseException';

class AwsException extends BaseException {
  constructor(
    statusCode: number,
    message: string,
    public awsCode: string,
    public awsMessage: string,
    public awsStorageClass?: string
  ) {
    super(statusCode, message);
    this.awsCode = awsCode;
    this.awsMessage = awsMessage;
    this.awsStorageClass = awsStorageClass;
  }
}

export default AwsException;
